export default __webpack_public_path__ + "static/media/ripple1.b0912ccc.png";